var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5896 15.3034L9.4111 16.4819C7.78392 18.1091 5.14573 18.1091 3.51855 16.4819C1.89136 14.8547 1.89136 12.2165 3.51855 10.5893L4.69706 9.4108M15.3037 10.5893L16.4822 9.4108C18.1094 7.78361 18.1094 5.14542 16.4822 3.51824C14.855 1.89106 12.2168 1.89106 10.5896 3.51824L9.4111 4.69675M7.08369 12.9167L12.917 7.08337",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink01);
export default __webpack_public_path__ + "static/media/link-01.6e79e69c.svg";
export { ForwardRef as ReactComponent };